<template>
  <div>
    <el-form
      :model="videoForm"
      :rules="rules"
      ref="videoForm"
      :inline="true"
      label-width="70px"
      class="demo-videoForm"
    >
      <el-form-item class="upload-video-wrapper" label="个人信息" prop="name">
        <el-input
          class="name-input"
          placeholder="姓名"
          v-model="videoForm.name"
        ></el-input>
      </el-form-item>
      <el-form-item class="upload-video-wrapper" label="" prop="company">
        <el-input
          class="company-input"
          placeholder="公司"
          v-model="videoForm.company"
        ></el-input>
      </el-form-item>
      <el-form-item class="upload-video-wrapper" label="" prop="phone">
        <el-input
          class="phone-input"
          placeholder="手机"
          v-model="videoForm.phone"
        ></el-input>
      </el-form-item>
      <el-form-item class="upload-video-wrapper" label="" prop="email">
        <el-input
          class="email-input"
          placeholder="邮箱"
          v-model="videoForm.email"
        ></el-input>
      </el-form-item>
      <br />
      <el-form-item
        class="upload-video-wrapper"
        label="描述需求"
        prop="requireText"
      >
        <div class="message-wrapper">
          <el-input
            type="textarea"
            :rows="8"
            class="message-textarea"
            placeholder="请详细描述一下您的需求，如视频的类型，用途，期望交付的时间等，以便客服为您提供优质的服务。"
            v-model="videoForm.requireText"
          ></el-input>
          <br />
          <div class="upload-wrapper">
            <p class="upload-text">如有参考资料或翻译片段，您可在此处上传</p>
            <el-upload
              ref="upload"
              class="upload-button-wrapper"
              name="fileInfo"
              :action="uploadVideoFileUrl"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :on-success="handleSuccess"
              :on-error="handleError"
              :before-upload="beforeUpload"
              :file-list="fileList"
              :limit="1"
            >
              <span class="upload-button">立即上传</span>
            </el-upload>
          </div>
        </div>
      </el-form-item>
      <br />
      <el-form-item class="submit-panel">
        <div
          class="submit-button"
          type="primary"
          @click="submitForm('videoForm')"
        >
          提交
        </div>
      </el-form-item>
    </el-form>
    <el-dialog :visible.sync="dialog.visible" width="30%">
      <div class="message-info">{{ dialog.message }}</div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { baseUrl } from "@/config";
// const baseUrl = "https://at-test1.youdao.com";
const uploadVideoFileUrl =
  baseUrl + "/user.do?method=uploadVideoApplyAttachment";
const submitInfoUrl = baseUrl + "/user.do?method=addVideoApply";
export default {
  data() {
    return {
      dialog: {
        visible: false,
        message: "",
      },
      uploadVideoFileUrl,
      videoForm: {
        urlFileName: "",
        srcFileName: "",
        name: "",
        company: "",
        phone: "",
        email: "",
        requireText: "",
      },
      fileList: [],
      // fileList: [{ name: "12312" }],
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[0-9]{10}$/,
            message: "请输入正确的手机号",
            trigger: "blur",
          },
        ],
        email: [
          { required: false, message: "请输入邮箱", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱格式", trigger: "blur" },
        ],
        requireText: [
          { required: true, message: "请输入需求", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.videoForm.urlFileName = "";
      this.videoForm.srcFileName = "";
      // this.initVideoEstimateInfo();
    },
    beforeUpload(file) {
      const isLt1G = file.size / 1024 / 1024 / 1024 < 1; // 限制文件大小为 1GB
      console.log(file.size / 1024 / 1024);
      console.log(isLt1G);
      if (!isLt1G) {
        this.$message.error("上传文件大小不能超过 1GB!");
      }
      return isLt1G; // 返回 true 表示上传文件，返回 false 则取消上传
    },
    handlePreview(file) {
      console.log(file);
    },
    handleSuccess(response, file, fileList) {
      console.log(response, file, fileList);
      console.log(response.urlFileName);
      console.log(response.srcFileName);
      this.videoForm.urlFileName = response.urlFileName;
      this.videoForm.srcFileName = response.srcFileName;
      // this.getVideoEstimateInfo();
    },
    handleError(err, file, fileList) {
      console.log(err, file, fileList);
    },
    submitForm(formName) {
      this.dialogVisible = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert("submit!");
          console.log(this.videoForm);
          axios.post(submitInfoUrl, this.videoForm).then((res) => {
            console.log(res);
            if (res.data.result === true) {
              // this.$message({
              //   message: "提交成功",
              //   type: "success",
              // });
              this.dialog.visible = true;
              this.dialog.message =
                "提交成功！专属客服会尽快与您联系，请耐心等待。";
              setTimeout(() => {
                this.dialog.visible = false;
                this.$refs[formName].resetFields();
                Object.assign(this.videoForm, {
                  urlFileName: "",
                  srcFileName: "",
                  name: "",
                  company: "",
                  phone: "",
                  email: "",
                  requireText: "",
                });
              }, 2000);
              this.$refs.upload.clearFiles();
              // window.location.reload();
            } else {
              this.dialog.visible = true;
              this.dialog.message = "提交失败，请稍后再试！";
              setTimeout(() => {
                this.dialog.visible = false;
              }, 2000);
              // this.$message({
              //   message: "提交失败",
              //   type: "error",
              // });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss">
.name-input,
.company-input,
.phone-input,
.email-input {
  width: 260px;
  height: 40px;
  flex-shrink: 0;
  // border-radius: 4px;
  // border: 1px solid #e6e7e8;
  // background: #fff;
}
.name-input,
.company-input,
.phone-input {
  margin-right: 28px;
}
.message-wrapper {
  width: 1129px;
  height: 228px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid #e6e7e8;
  position: relative;
  box-sizing: border-box;
}
.message-textarea {
}
.upload-wrapper {
  overflow: hidden;
  position: absolute;
  bottom: 4px;
  left: 12px;
}
.upload-text {
  color: #626469;
  font-family: PingFang SC;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 40px; /* 200% */
  float: left;
  margin: 0;
}
.upload-button-wrapper {
  float: left;
  margin-left: 4px;
  overflow: hidden;
  width: 500px;
  position: relative;
}
.upload-button {
  color: #4d71ff;
  font-family: PingFang SC;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 200% */
}
.submit-panel {
  margin-left: 473px;
}
.submit-button {
  width: 254px;
  height: 42px;
  flex-shrink: 0;
  border-radius: 4px;
  background: #fb3a4d;
  color: #fff;
  text-align: center;
  /* H6 - 14pt Medium */
  font-family: PingFang SC;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 42px; /* 185.714% */
  cursor: pointer;
}
.message-info {
  text-align: center;
  color: #2a2b2e;
  font-family: PingFang SC;
  font-size: 20px;
  font-style: normal;
  line-height: normal;
}
.el-upload {
  float: left;
  // position: absolute;
}
.el-upload-list {
  float: left;
  margin-left: 20px;
  width: 400px;
  // position: absolute;
}
.el-input.is-active .el-input__inner,
.el-input__inner:focus {
  border-color: #dcdfe6;
  box-shadow: none;
}
.el-textarea__inner {
  border: none;
  resize: none;
}
.el-form-item__label {
  color: #2a2b2e;
  text-align: right;
  font-family: PingFang SC;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 21px */
  padding-right: 14px;
  padding-top: 9px;
}
.el-upload-list__item {
  background: transparent !important;
}
.el-upload-list__item.is-success .el-upload-list__item-name:focus,
.el-upload-list__item.is-success .el-upload-list__item-name:hover {
  background-color: #fff;
  color: #2b333d;
  font-family: PingFang SC;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  // background: #fff !important;
}
.el-upload-list__item-name {
  color: #2b333d;
  font-family: PingFang SC;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  background: #fff !important;
}
.el-progress-bar__inner {
  background-color: rgba(251, 74, 62, 1);
}
.el-form--inline .el-form-item {
  margin-right: 0;
}
.el-form-item__label {
  color: #2a2b2e;
  text-align: right;
  font-family: PingFang SC;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 21px */
}
.el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
.el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
  content: "";
  margin: 0;
}
.el-form-item.is-error .el-input__inner,
.el-form-item.is-error .el-input__inner:focus,
.el-message-box__input input.invalid,
.el-message-box__input input.invalid:focus {
  border-color: #dcdfe6;
  box-shadow: none;
  // border-color: #f56c6c;
}
.el-form-item.is-error .el-textarea__inner,
.el-form-item.is-error .el-textarea__inner:focus {
  border: none;
}
.el-textarea__inner {
  border-color: #fff;
  box-shadow: none;
  padding-top: 12px;
}
.el-textarea__inner:focus {
  border: none;
  border-color: #fff;
}
.el-dialog {
  background: #fafbfd;
  border-radius: 4px;
}
.el-dialog__header {
  padding: 0;
}
.el-dialog__title {
  color: #2a2b2e;
  font-family: PingFang SC;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding-top: 8px;
}
.el-dialog__headerbtn {
  top: 16px;
  right: 16px;
  // background: url("~@/assets/images/dialog-delete-icon@2x.png");
  background-size: cover;
  width: 16px;
  height: 16px;
}
.el-dialog__headerbtn .el-dialog__close:before {
  content: "";
}
.el-range-editor.is-active,
.el-range-editor.is-active:hover,
.el-select .el-input.is-focus .el-input__inner {
  border-color: #dcdfe6;
  box-shadow: none;
}
.el-select .el-input__inner:focus {
  border-color: #dcdfe6;
  box-shadow: none;
}
</style>
